import * as Sentry from '@sentry/vue'
import { getPosthog } from '@/plugins/postHog'
import { useMainStore } from '@/stores/MainStore'

const ExpectedEvents = ['unhandledrejection_error_thrown']

// @throws
const doValidateEvent = args => {
  let isValid = true

  if (!args) {
    console.error('No event args supplied!')
    isValid = false
  } else if (!args?.event) {
    console.error('No event supplied!')
    isValid = false
  } else if (!ExpectedEvents.includes(args?.event)) {
    console.error('Unrecognised event supplied!')
    isValid = false
  }

  if (!isValid) {
    throw new Error(`Invalid event args: ${JSON.stringify(args)}`)
  }
}

const init = ({ posthogSessionId }) => {
  const posthog = getPosthog()
    
  if (import.meta.env.VITE_APP_ENVIRONMENT !== 'prod') {
    console.debug('Initialising Posthog with Session ID:', posthogSessionId)
  }

  if (!posthogSessionId) {
    const msg = 'Could not initialise Posthog Session ID!'

    console.error(msg)
    Sentry.captureException(msg)
  }

  posthog.identify(posthogSessionId)
}

const trackEvent = args => {
  const mainStore = useMainStore()
  const posthog = getPosthog()
 
  if (import.meta.env.VITE_APP_ENVIRONMENT !== 'prod') {
    console.debug('Tracking event:', args, mainStore.posthogSessionId)
  }

  try {
    doValidateEvent(args)
    
    // Capture the event
    const enrichedCaptureProperties = {
      // Insert any 'global' properties here as required
    }

    const capturePayload = {
      ...args.data,
      ...enrichedCaptureProperties,
    }

    if (import.meta.env.VITE_APP_ENVIRONMENT !== 'prod') {
      console.debug('Capturing PostHog Event:', capturePayload)
    }

    posthog.capture(args.event, capturePayload)
  } catch (err) {
    console.error('Failed to track event!', err)
    Sentry.captureException(err, { extra: args })
  }
}

const trackPageViewEvent = to => {
  // TODO set up route events
}

export default {
  init,
  trackEvent,
  trackPageViewEvent,
}
